'use client'

import CloseButton from '@component/closeButton'
import IconLogo from '@icon/const/logo-inline.svg'
import { global } from '@store/index'
import { getFullPath } from '@utils'
import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect, useState } from 'react'
import { useSessionStorage } from 'react-use'
import { useRecoilState } from 'recoil'

export default function OpenApp() {
  const searchParams = useSearchParams()
  const pathname = usePathname()
  const [globalState] = useRecoilState(global)


  const url = getFullPath(pathname)
  const isShowOpen = searchParams.get('openApp') === 'hidden'
  const isFromApp = searchParams.get('from') === 'app'

  const [visible, setVisible] = useState(false)
  const [sessionShow, setSessionShow] = useSessionStorage('open-app-banner', true)
  useEffect(() => {
    if (sessionShow && globalState.isShowOpenApp && !isFromApp && !isShowOpen) {
      setVisible(true)
    } else {
      setVisible(false)
    }
  }, [sessionShow, isShowOpen, isFromApp, globalState.isShowOpenApp])

  return visible && (
    <div className='sm:hidden bg-font relative z-[101] border-b h-50 pl-12 pr-6 gap-x-6 flex items-center' id="open-app-banner">
      <IconLogo></IconLogo>
      <div className='mr-auto text-xs text-white'>
        <strong>OneRoof</strong>
        <div>Open in the OneRoof app</div>
      </div>
      <a href={getFireBaseLink(url)} className='w-70 h-25 inline-flex items-center justify-center bg-white rounded-full uppercase text-xs' data-noprogress>open</a>
      <CloseButton iconClassName='!text-white' onClick={() => setSessionShow(false)}></CloseButton>
    </div>
  )
}

function getFireBaseLink(url) {
  return `https://r6c3w.app.goo.gl/?link=${url}&apn=com.nzme.oneroof&afl=https://www.oneroof.co.nz/download&ibi=com.hougarden.iHomes&isi=1336312690&ius=iOSOfOneRoof&efr=1`
}

export function ShowOpenApp() {
  const [_, setGlobalState] = useRecoilState(global)
  useEffect(() => {
    setGlobalState(prev => ({ ...prev, isShowOpenApp: true }))

    return () => {
      setGlobalState(prev => ({ ...prev, isShowOpenApp: false }))
    }
  }, [setGlobalState])
}
